const productParameters = {
  "categories": [
    {
      "categoryName": "Digital Oscilloscope1",
      "categoryId": "digital-oscilloscope",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Digital_Oscilloscope.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Benchtop Oscilloscope",
          "categoryId": "benchtop-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 1014D 2in1 Oscilloscope Signal Generator",
              "model": "1014D",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    // "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014E",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014F",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014G",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014H",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014J",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014K",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014L",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014M",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            },{
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014N",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Tablet Oscilloscope",
          "categoryId": "tablet-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® DPOS350P Oscilloscope Signal Generator Spectrum Analyzer Frequency Response Analyzer",
              "model": "DPOS350P",
              "description": "Dual Channel 350MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOS350P.jpg?v=1741079875",
              "price": "$279.99",
              "url": "/products/dpos350p",
              "variants": [
                {
                  "name": "US Plug",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-dpos350p-4-in-1-350mhz-1gsps-tablet-oscilloscope-signal-generator-spectrum-analyzer-frequency-response-analyzerdigital-oscilloscopefnirsifnirsi-8571374.jpg?v=1751709887",
                  "price":"$279.99",
                  "compareAtPrice":"$369.99",
                  "variantId":"46301842931930"
                },{
                  "name": "EU Plug",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-dpos350p-4-in-1-350mhz-1gsps-tablet-oscilloscope-signal-generator-spectrum-analyzer-frequency-response-analyzerdigital-oscilloscopefnirsifnirsi-1917864.jpg?v=1751709888",
                  "price":"$279.99",
                  "compareAtPrice":"$369.99",
                  "variantId":"46301842964698"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    // "ScreenMaterial":"IPS Touchscreen",
                    "Backlight":"",
                    "ScreenResolution":"1024*600",
                    "Charging":"QC18W - 12V/1.5A",
                    "Battery":"3.7V 8000mAh Lithium Battery",
                    "SupportFunctions":"Oscilloscope, Signal Generator, Frequency Response Analyzer, Spectrum Analyzer",
                    "StandbyTime":"About 3 Hours",
                    "ProductSize":"190*128*37mm",
                    "Weight":"0.755kg",
                    "Language":"Chinese / English / Russian / Portuguese",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"Single channel 350MHz, dual channel 150Mhz",
                    "MemoryDepth":"60Kpts",
                    "InputImpedance":"1MΩ / 14PF",
                    "TimeBaseRange":"5nS~50S",
                    "VerticalSensitivity":"2mV~20V(1X)",
                    "MaximumMeasurementVoltage":"16mV~160V(1X)",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, RMS, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"20M",
                    "VerticalResolution":"8-bit, supports switching between 9-16 bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"120MB",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"50M: Sine wave, Ringing signal<br>10M: Square wave, Half-wave, Full-wave<br>5M: Triangle wave, Rising sawtooth, Falling sawtooth, Staircase wave, Sine superposition, Sampling function, DC<br>3M: Exponential wave, Square root wave, Clipped wave",
                    "Amplitude":"0 ~ 5VPP",
                    "Bias":"-2.500V ~ +2.500V",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                },{
                  "type": "Frequency Response Analyzer",
                  "content": {
                    "ExcitationSignalFrequency":"100Hz ~ 50MHz",
                    "ExcitationSignalAmplitude":"0 ~ 5VPP",
                    "ExcitationSignalOffset":"-2.5V ~ +2.5V",
                    "ExcitationFrequencyCount":"20 ~ 500",
                    "CursorMeasurement":"Frequency / Gain / Phase",
                    "WorkingMode":"Single / Cycle"
                  }
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Handheld Oscilloscope",
          "categoryId": "handheld-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 2C53T Handheld 3in1 Oscilloscope Multimeter Signal Generator",
              "model": "2C53T",
              "description": "Dual Channel 50MHz 250MS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2C53T.jpg?v=1740568119",
              "price": "$103.24",
              "url": "/products/2c53t",
              "variants": [
                {
                  "name": "Optional P6100x2",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-2c53t-50mhz-250mss-handheld-3in1-oscilloscope-multimeter-signal-generatordigital-oscilloscopefnirsifnirsi-7171258.jpg?v=1751709904",
                  "price":"$106.24",
                  "compareAtPrice":"$195.56",
                  "variantId":"45895611810010"
                },{
                  "name": "Standard P6100x1",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-2c53t-50mhz-250mss-handheld-3in1-oscilloscope-multimeter-signal-generatordigital-oscilloscopefnirsifnirsi-2858716.jpg?v=1751709904",
                  "price":"$103.24",
                  "compareAtPrice":"$170.00",
                  "variantId":"45895611777242"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"2.8 inches",
                    // "ScreenMaterial":"TFT",
                    "Backlight":"Brightness adjustable",
                    "ScreenResolution":"320*240",
                    "Charging":"TYPE-C (5V/1A)",
                    "Battery":"3000mAh Lithium Battery",
                    "SupportFunctions":"Oscilloscope, Signal Generator, Digital Multimeter",
                    "StandbyTime":"About 7 Hours",
                    "ProductSize":"167*89*35mm",
                    "Weight":"0.3kg",
                    "Language":"Chinese / English",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"250MS/s",
                    "AnalogBandwidth":"50MHz",
                    "MemoryDepth":"1Kpts (1024 data points)",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS-20S",
                    "VerticalSensitivity":"10mV/div-10V/div（1X）",
                    "MaximumMeasurementVoltage":"±400V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"OFF、500ms、1s、∞",
                    "Calculation":"8 basic operations + FFT operation",
                    "MeasurementData":"Max, Min, Avg, RMS, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"ADC+MCU+FPGA",
                    "FGPA":"",
                    "WaveformRefreshRate":"",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"1Hz-50KHz",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine wave, Square wave, Sawtooth wave, Half-wave, Full-wave, Positive staircase wave, Negative staircase wave, Exponential rise, Exponential decay, DC signal, Multi-tone, Sync pulse, Lorentz wave",
                    "Amplitude":"0.1-3.0V",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            }
          ]
        }
      ]  
    },
    {
      "categoryName": "Digital Oscilloscope2",
      "categoryId": "digital-oscilloscope",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Digital_Oscilloscope.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Benchtop Oscilloscope",
          "categoryId": "benchtop-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014D-1",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"100MHz",
                    "MemoryDepth":"240Kbit",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS~50S",
                    "VerticalSensitivity":"50mV~500V",
                    "MaximumMeasurementVoltage":"1X: max 40V<br>10X: max AC 140V, DC 400Vpp<br>With 100X probe: up to 1000V, AC 700V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Tablet Oscilloscope",
          "categoryId": "tablet-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® DPOS350P Oscilloscope Signal Generator Spectrum Analyzer Frequency Response Analyzer",
              "model": "DPOS350P-1",
              "description": "Dual Channel 350MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOS350P.jpg?v=1741079875",
              "price": "$279.99",
              "url": "/products/dpos350p",
              "variants": [
                {
                  "name": "US Plug",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-dpos350p-4-in-1-350mhz-1gsps-tablet-oscilloscope-signal-generator-spectrum-analyzer-frequency-response-analyzerdigital-oscilloscopefnirsifnirsi-8571374.jpg?v=1751709887",
                  "price":"$279.99",
                  "compareAtPrice":"$369.99",
                  "variantId":"46301842931930"
                },{
                  "name": "EU Plug",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-dpos350p-4-in-1-350mhz-1gsps-tablet-oscilloscope-signal-generator-spectrum-analyzer-frequency-response-analyzerdigital-oscilloscopefnirsifnirsi-1917864.jpg?v=1751709888",
                  "price":"$279.99",
                  "compareAtPrice":"$369.99",
                  "variantId":"46301842964698"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"IPS Touchscreen",
                    "Backlight":"",
                    "ScreenResolution":"1024*600",
                    "Charging":"QC18W - 12V/1.5A",
                    "Battery":"3.7V 8000mAh Lithium Battery",
                    "SupportFunctions":"Oscilloscope, Signal Generator, Frequency Response Analyzer, Spectrum Analyzer",
                    "StandbyTime":"About 3 Hours",
                    "ProductSize":"190*128*37mm",
                    "Weight":"0.755kg",
                    "Language":"Chinese / English / Russian / Portuguese",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"1GS/s",
                    "AnalogBandwidth":"Single channel 350MHz, dual channel 150Mhz",
                    "MemoryDepth":"60Kpts",
                    "InputImpedance":"1MΩ / 14PF",
                    "TimeBaseRange":"5nS~50S",
                    "VerticalSensitivity":"2mV~20V(1X)",
                    "MaximumMeasurementVoltage":"16mV~160V(1X)",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"",
                    "Calculation":"",
                    "MeasurementData":"Max, Min, Avg, RMS, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"20M",
                    "VerticalResolution":"8-bit, supports switching between 9-16 bit",
                    "ProbeAttenuationFactor":"1X/10X/100X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"120MB",
                    "HardwareArchitecture":"",
                    "FGPA":"",
                    "WaveformRefreshRate":"50000wfm/s",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"50M: Sine wave, Ringing signal<br>10M: Square wave, Half-wave, Full-wave<br>5M: Triangle wave, Rising sawtooth, Falling sawtooth, Staircase wave, Sine superposition, Sampling function, DC<br>3M: Exponential wave, Square root wave, Clipped wave",
                    "Amplitude":"0 ~ 5VPP",
                    "Bias":"-2.500V ~ +2.500V",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                },{
                  "type": "Frequency Response Analyzer",
                  "content": {
                    "ExcitationSignalFrequency":"100Hz ~ 50MHz",
                    "ExcitationSignalAmplitude":"0 ~ 5VPP",
                    "ExcitationSignalOffset":"-2.5V ~ +2.5V",
                    "ExcitationFrequencyCount":"20 ~ 500",
                    "CursorMeasurement":"Frequency / Gain / Phase",
                    "WorkingMode":"Single / Cycle"
                  }
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Handheld Oscilloscope",
          "categoryId": "handheld-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 2C53T Handheld 3in1 Oscilloscope Multimeter Signal Generator",
              "model": "2C53T-1",
              "description": "Dual Channel 50MHz 250MS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2C53T.jpg?v=1740568119",
              "price": "$103.24",
              "url": "/products/2c53t",
              "variants": [
                {
                  "name": "Optional P6100x2",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-2c53t-50mhz-250mss-handheld-3in1-oscilloscope-multimeter-signal-generatordigital-oscilloscopefnirsifnirsi-7171258.jpg?v=1751709904",
                  "price":"$106.24",
                  "compareAtPrice":"$195.56",
                  "variantId":"45895611810010"
                },{
                  "name": "Standard P6100x1",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-2c53t-50mhz-250mss-handheld-3in1-oscilloscope-multimeter-signal-generatordigital-oscilloscopefnirsifnirsi-2858716.jpg?v=1751709904",
                  "price":"$103.24",
                  "compareAtPrice":"$170.00",
                  "variantId":"45895611777242"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"2.8 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"Brightness adjustable",
                    "ScreenResolution":"320*240",
                    "Charging":"TYPE-C (5V/1A)",
                    "Battery":"3000mAh Lithium Battery",
                    "SupportFunctions":"Oscilloscope, Signal Generator, Digital Multimeter",
                    "StandbyTime":"About 7 Hours",
                    "ProductSize":"167*89*35mm",
                    "Weight":"0.3kg",
                    "Language":"Chinese / English",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Oscilloscope Parameters",
                  "content": {
                    "Channel":"Dual Channel",
                    "SamplingRate":"250MS/s",
                    "AnalogBandwidth":"50MHz",
                    "MemoryDepth":"1Kpts (1024 data points)",
                    "InputImpedance":"1MΩ",
                    "TimeBaseRange":"10nS-20S",
                    "VerticalSensitivity":"10mV/div-10V/div（1X）",
                    "MaximumMeasurementVoltage":"±400V",
                    "TriggerMode":"Automatic, Normal, Ningle",
                    "TriggerType":"Rising edge, Falling edge",
                    "DisplayMode":"Y-T/Roll/X-Y",
                    "Coupling":"AC/DC",
                    "SaveImage":"✔",
                    "ExportImage":"✔",
                    "CursorMeasurement":"✔",
                    "Afterglow":"OFF、500ms、1s、∞",
                    "Calculation":"8 basic operations + FFT operation",
                    "MeasurementData":"Max, Min, Avg, RMS, Pk-Pk, Pk, Freq, Per, +Width, –Width, +Duty, –Duty",
                    "BandwidthLimit":"",
                    "VerticalResolution":"8-bit",
                    "ProbeAttenuationFactor":"1X/10X",
                    "TriggerLevelRange":"8 grids (+/-)",
                    "StorageSpace":"",
                    "HardwareArchitecture":"ADC+MCU+FPGA",
                    "FGPA":"",
                    "WaveformRefreshRate":"",
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"1Hz-50KHz",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine wave, Square wave, Sawtooth wave, Half-wave, Full-wave, Positive staircase wave, Negative staircase wave, Exponential rise, Exponential decay, DC signal, Multi-tone, Sync pulse, Lorentz wave",
                    "Amplitude":"0.1-3.0V",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            }
          ]
        }
      ]  
    },
    {
      "categoryName": "Oscilloscope3",
      "categoryId": "digital-oscilloscope",
      "categoryImage": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_Product_Category_Digital_Oscilloscope.svg?v=1750762077",
      "subCategories": [
        {
          "categoryName": "Benchtop Oscilloscope",
          "categoryId": "benchtop-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 1014D 2in1 Dual Channel Digital Oscilloscope Signal Generator",
              "model": "1014D-2",
              "description": "Dual Channel 100MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_1014D.jpg?v=1740568025",
              "price": "$159.00",
              "url": "/products/1014d",
              "variants": [
                {
                  "name": "Standard",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-8266834.jpg?v=1751710012",
                  "price":"$159.00",
                  "compareAtPrice":"$364.99",
                  "variantId":"45192685846746"
                  // "url": "/products/1014d?variant=45192685846746"
                },{
                  "name": "Add P4100 Probe",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-1014d-2-in-1-dual-channel-100mhz-1gss-digital-oscilloscope-signal-generatordigital-oscilloscopefnirsifnirsi-9088314.jpg?v=1751710012",
                  "price":"$170.99",
                  "compareAtPrice":"$388.99",
                  "variantId":"45192685879514"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"",
                    "ScreenResolution":"800*480",
                    "Charging":"5V 2A",
                    "Battery":"",
                    "SupportFunctions":"Oscilloscope, Signal Generator",
                    "StandbyTime":"",
                    "ProductSize":"310*145*70mm",
                    "Weight":"0.963kg",
                    "Language":"Chinese and English (need to flash the firmware)",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine (10M), Square, Triangle, Positive Sawtooth, Negative Sawtooth, Staircase, Half-wave Rectified, Full-wave Rectified, Exponential, Logarithmic, Anti-Exponential, Root, Multi-tone, Sync Pulse, Others (1M), Clipped Output: 1MHz max",
                    "Amplitude":"2.5VPP",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Tablet Oscilloscope",
          "categoryId": "tablet-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® DPOS350P Oscilloscope Signal Generator Spectrum Analyzer Frequency Response Analyzer",
              "model": "DPOS350P-2",
              "description": "Dual Channel 350MHz 1GS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOS350P.jpg?v=1741079875",
              "price": "$279.99",
              "url": "/products/dpos350p",
              "variants": [
                {
                  "name": "US Plug",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-dpos350p-4-in-1-350mhz-1gsps-tablet-oscilloscope-signal-generator-spectrum-analyzer-frequency-response-analyzerdigital-oscilloscopefnirsifnirsi-8571374.jpg?v=1751709887",
                  "price":"$279.99",
                  "compareAtPrice":"$369.99",
                  "variantId":"46301842931930"
                },{
                  "name": "EU Plug",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-dpos350p-4-in-1-350mhz-1gsps-tablet-oscilloscope-signal-generator-spectrum-analyzer-frequency-response-analyzerdigital-oscilloscopefnirsifnirsi-1917864.jpg?v=1751709888",
                  "price":"$279.99",
                  "compareAtPrice":"$369.99",
                  "variantId":"46301842964698"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"7 inches",
                    "ScreenMaterial":"IPS Touchscreen",
                    "Backlight":"",
                    "ScreenResolution":"1024*600",
                    "Charging":"QC18W - 12V/1.5A",
                    "Battery":"3.7V 8000mAh Lithium Battery",
                    "SupportFunctions":"Oscilloscope, Signal Generator, Frequency Response Analyzer, Spectrum Analyzer",
                    "StandbyTime":"About 3 Hours",
                    "ProductSize":"190*128*37mm",
                    "Weight":"0.755kg",
                    "Language":"Chinese / English / Russian / Portuguese",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"50M: Sine wave, Ringing signal<br>10M: Square wave, Half-wave, Full-wave<br>5M: Triangle wave, Rising sawtooth, Falling sawtooth, Staircase wave, Sine superposition, Sampling function, DC<br>3M: Exponential wave, Square root wave, Clipped wave",
                    "Amplitude":"0 ~ 5VPP",
                    "Bias":"-2.500V ~ +2.500V",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                },{
                  "type": "Frequency Response Analyzer",
                  "content": {
                    "ExcitationSignalFrequency":"100Hz ~ 50MHz",
                    "ExcitationSignalAmplitude":"0 ~ 5VPP",
                    "ExcitationSignalOffset":"-2.5V ~ +2.5V",
                    "ExcitationFrequencyCount":"20 ~ 500",
                    "CursorMeasurement":"Frequency / Gain / Phase",
                    "WorkingMode":"Single / Cycle"
                  }
                }
              ]
            }
          ]
        },
        {
          "categoryName": "Handheld Oscilloscope",
          "categoryId": "handheld-oscilloscope",
          "products": [
            {
              "productName": "FNIRSI® 2C53T Handheld 3in1 Oscilloscope Multimeter Signal Generator",
              "model": "2C53T-2",
              "description": "Dual Channel 50MHz 250MS/s",
              "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_2C53T.jpg?v=1740568119",
              "price": "$103.24",
              "url": "/products/2c53t",
              "variants": [
                {
                  "name": "Optional P6100x2",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-2c53t-50mhz-250mss-handheld-3in1-oscilloscope-multimeter-signal-generatordigital-oscilloscopefnirsifnirsi-7171258.jpg?v=1751709904",
                  "price":"$106.24",
                  "compareAtPrice":"$195.56",
                  "variantId":"45895611810010"
                },{
                  "name": "Standard P6100x1",
                  "image": "https://cdn.shopify.com/s/files/1/0694/8310/2426/files/fnirsi-2c53t-50mhz-250mss-handheld-3in1-oscilloscope-multimeter-signal-generatordigital-oscilloscopefnirsifnirsi-2858716.jpg?v=1751709904",
                  "price":"$103.24",
                  "compareAtPrice":"$170.00",
                  "variantId":"45895611777242"
                }
              ],
              "parameters": [
                {
                  "type": "General Parameters",
                  "content": {
                    "ScreenSize":"2.8 inches",
                    "ScreenMaterial":"TFT",
                    "Backlight":"Brightness adjustable",
                    "ScreenResolution":"320*240",
                    "Charging":"TYPE-C (5V/1A)",
                    "Battery":"3000mAh Lithium Battery",
                    "SupportFunctions":"Oscilloscope, Signal Generator, Digital Multimeter",
                    "StandbyTime":"About 7 Hours",
                    "ProductSize":"167*89*35mm",
                    "Weight":"0.3kg",
                    "Language":"Chinese / English",
                    "FirmwareUpgrade":"✔"
                  }
                },{
                  "type": "Signal Generator",
                  "content": {
                    "Frequency":"1Hz-50KHz",
                    "Channel":"Single Channel",
                    "Different waveform output frequencies":"Sine wave, Square wave, Sawtooth wave, Half-wave, Full-wave, Positive staircase wave, Negative staircase wave, Exponential rise, Exponential decay, DC signal, Multi-tone, Sync pulse, Lorentz wave",
                    "Amplitude":"0.1-3.0V",
                    "Bias":"",
                    "Square Wave Duty Cycle":"0-100%"
                  }
                }
              ]
            }
          ]
        }
      ]  
    }
  ]
};